/**
 * Правка строки запроса ПО ОБРАЗЦУ, а не по снимку рендера:
 * `setParams((prev) => patchParams(prev, { q: "…" }), { replace: true })`.
 *
 * Экраны строили `new URLSearchParams(params)` из `params` того рендера, в
 * котором запомнили функцию `set`, — и дебаунс поиска (350 мс) переписывал
 * адрес тем снимком, стирая чип, который успели кликнуть за это время
 * (аудит фронта 12.10.26, B16/B41/B60). Функциональный `setParams` даёт
 * свежий адрес в момент записи. Пустое значение снимает ключ.
 */
export function patchParams(prev: URLSearchParams, patch: Record<string, string>): URLSearchParams {
  const next = new URLSearchParams(prev);
  for (const [key, value] of Object.entries(patch)) {
    if (value) next.set(key, value);
    else next.delete(key);
  }
  return next;
}
